var FilterableResult = require('../General/FilterableResult').FilterableResult;
import { AbconetApi } from '../General/AbconetApi';
import moment from "moment";

export class ServiceListing extends React.Component {

    constructor(props) {
        super(props);
        this.filterableResult = React.createRef();
        this.state = {

        };
    }


    renderRows(row) {
        var startDate = row.startDate ? moment(row.startDate).format("DD/MM/YYYY") : "";
        var dueDate = row.dueDate ? moment(row.dueDate).format("DD/MM/YYYY") : "";


        var finished = row.dueDate ? moment(row.dueDate) : moment();

        var duration = moment.duration(finished.diff(row.startDate));

        return (
            <div className="item pl-0 pr-0" key={row.id}>
                <div className="row">
                    <div className="col-3 text-left">
                        <a href={`/services/${row.id}`}>{row.name}</a>
                    </div>
                    <div className="col-3 text-left" >
                        {startDate}
                    </div>
                    <div className="col-3 text-left" >
                        {row.workflowStatus}
                    </div>
                    <div className="col-3 text-left" >
                        {duration.humanize()}
                    </div>
                </div>
            </div>
        );
    }

    renderData(resultCollection) {
        return (
            <div className="list-group">
                <div className="row header">
                    <div className="col-3 col-hd text-left">
                        Service ID
                    </div>
                    <div className="col-3 col-hd text-left" >
                        Lodged Date
                    </div>
                    <div className="col-3 col-hd text-left">
                        Status
                    </div>
                    <div className="col-3 col-hd text-left">
                        Downtime
                    </div>
                </div>

                {resultCollection.map(this.renderRows.bind(this))}
            </div>
        );
    }

    render() {
        var initialState = this.props.initialState;
        var baseUrl = null;

        if (this.props.limitToEquipment != null) {
            initialState = {
                filterCollection: [{
                    "type": "Dropdown",
                    "value": this.props.limitToEquipment.id,
                    "name": "equipmentList",
                },{
                        "type": "Dropdown",
                        "value": this.props.limitToEquipment.address != null ? this.props.limitToEquipment.address.id : 0,
                        "name": "siteIdList",
                    }],
                resultMetadata: {
                    pageSize: 5
                },

                hideFilter: true
            };
            baseUrl = "/services/"
        }

        return (
            <div className="service-listing">
                <FilterableResult ref={this.filterableResult} initialState={initialState} renderData={this.renderData.bind(this)} baseUrl={baseUrl} />
            </div>
        );
    }

}